// src/api/unifiApi.js
// UniFi client→site mapping, used by the Client Register (Settings → Row 3).
// The mapping lives in a backend blob (unifi-client-config) — NOT in saveSnapshot —
// because the server-side sync reads it directly. This api is the only writer.
import apiClient from "./apiClient";

const BASE = "/api/unifi";

// Mapping joined to the last sync outcome per client.
// → { lastSyncAt, selfHostedConfigured, clients: [{companyId, siteId, state, ...}] }
export async function getUnifiRegister() {
  const res = await apiClient.get(`${BASE}/register`);
  return res.data;
}

// Every site on the UniFi account, for the picker. Hits the UniFi cloud API,
// so call it lazily (Settings tab only) rather than on app load.
export async function getAvailableSites() {
  const res = await apiClient.get(`${BASE}/available-sites`, { timeout: 45000 });
  return res.data?.data || [];
}

// Assign / change one client's site. accessMode is derived server-side from hostId.
export async function setClientUnifi(companyId, { siteId, siteName, hostId, reportType, companyName, siteLabel }) {
  const res = await apiClient.put(`${BASE}/config/${companyId}`, { siteId, siteName, hostId, reportType, companyName, siteLabel });
  return res.data?.data;
}

export async function clearClientUnifi(companyId) {
  const res = await apiClient.delete(`${BASE}/config/${companyId}`);
  return res.data;
}

// Kick off a sync of all mapped clients. Returns immediately; the backend runs
// it in the background, so re-fetch the register a little later for results.
export async function syncUnifi() {
  const res = await apiClient.post(`${BASE}/sync`);
  return res.data;
}
